import { ENDPOINTS } from '@/settings/endpoints';
import axios from 'axios';
import SentryClient from '../sentry';
import { PEGASUS_MUSTANG_EARLY_GRADUATION_NAMESPACE } from '@/settings/constants';

interface GetEarlyGraduationeligibilityResponseType {
  data: { canGraduateEarly: boolean };
}

export default class EarlyGraduationService {
  static async getCourseEligibility(
    descomplicaToken: string,
    dexCourseId: string,
  ): Promise<boolean> {
    try {
      const response = await axios.get<GetEarlyGraduationeligibilityResponseType>(
        `${PEGASUS_MUSTANG_EARLY_GRADUATION_NAMESPACE}/eligibility`,
        {
          baseURL: ENDPOINTS.pegasusMustang as string,
          params: {
            courseId: dexCourseId,
          },
          headers: {
            Authorization: `Bearer ${descomplicaToken}`,
          },
        },
      );

      const eligibility = response.data.data.canGraduateEarly;
      return eligibility;
    } catch (err) {
      SentryClient.captureError(err);
    }

    return false;
  }
}
